export default __webpack_public_path__ + "media/examples/custom-ef402afc.jpg";